export const USER_STATUSES = ["pending", "active", "suspended"];
export const USER_STATUS_LABELS = {
    pending: "Pending",
    active: "Active",
    suspended: "Suspended",
};
export const ORG_STATUSES = ["active", "suspended"];
export const ORG_STATUS_LABELS = {
    active: "Active",
    suspended: "Suspended",
};
/** Karigar KYC pipeline. See ARCHITECTURE §7. */
export const KYC_STATUSES = [
    "not_submitted",
    "pending_counter",
    "pending_sales_rep",
    "pending_org_admin",
    "approved",
    "rejected",
];
/**
 * What a person is shown. The values above are database enums and must never
 * reach a screen — a karigar list that reads "pending_counter" is showing the
 * schema, not the state of the work.
 */
export const KYC_STATUS_LABELS = {
    not_submitted: "Not submitted",
    // All three now wait on the org admin alone (approval.ts) — the names are legacy.
    pending_counter: "Awaiting approval",
    pending_sales_rep: "Awaiting approval",
    pending_org_admin: "Awaiting approval",
    approved: "Approved",
    rejected: "Rejected",
};
/** The states an approver can act on. */
export const PENDING_KYC_STATUSES = [
    "pending_counter",
    "pending_sales_rep",
    "pending_org_admin",
];
/** Which role clears which pending state. */
export const KYC_APPROVER_ROLE = {
    pending_counter: "counter",
    pending_sales_rep: "sales_rep",
    pending_org_admin: "org_admin",
};
/** D-07 — chosen per organization. */
export const APPROVAL_MODES = ["counter_only", "counter_then_sales_rep"];
export const APPROVAL_MODE_LABELS = {
    counter_only: "Counter only",
    counter_then_sales_rep: "Counter + Sales Rep",
};
/**
 * Reserved slugs — an organization may never claim one of these, or it would
 * shadow a platform route.
 */
export const RESERVED_SLUGS = [
    "api",
    "admin",
    "super-admin",
    "superadmin",
    "login",
    "logout",
    "register",
    "auth",
    "public",
    "assets",
    "static",
    "www",
    "app",
    "gatiq",
    "help",
    "support",
    "docs",
    "status",
    "health",
    "set-password",
    "forgot-password",
    "install",
    "privacy",
    "terms",
];
//# sourceMappingURL=statuses.js.map